export default [
  {
    path: '/dispatch/:account',
    component: () => import(/* webpackChunkName: "dispatch" */ '@/layouts/Dispatch.vue'),
    meta: { auth: true },
    children: [
      {
        name: 'DispatchLoadOrders',
        path: 'load',
        component: () => import(/* webpackChunkName: "dispatch" */ '@/views/dispatch/DispatchLoadOrders.vue')
      },
      {
        name: 'DispatchPlanRoutes',
        path: 'plan',
        component: () => import(/* webpackChunkName: "dispatch" */ '@/views/dispatch/DispatchPlanRoutes.vue')
      },
    ]
  }
]
